/**
 * Shared formatting helpers for entity change cards.
 */

export function formatEnumValue(
  value: string | null | undefined,
): string | null {
  if (!value) return null;
  return value
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatDate(
  dateStr: string | null | undefined,
): string | null {
  if (!dateStr) return null;
  try {
    return new Date(dateStr).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return dateStr;
  }
}

export function formatFieldValue(value: unknown, isDate = false): string {
  if (value === null || value === undefined) return '\u2014';
  if (typeof value === 'string')
    return isDate ? (formatDate(value) ?? '\u2014') : value || '\u2014';
  if (typeof value === 'number') return String(value);
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (Array.isArray(value)) {
    if (value.length === 0) return '\u2014';
    if (value.every((v) => typeof v === 'string')) return value.join(', ');
    return `${value.length} items`;
  }
  return JSON.stringify(value, null, 2);
}

export function formatOldValue(value: unknown): string {
  if (value === null || value === undefined) return '(empty)';
  if (typeof value === 'string') return value || '(empty)';
  if (typeof value === 'number') return String(value);
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (Array.isArray(value)) {
    if (value.length === 0) return '(empty)';
    if (value.every((v) => typeof v === 'string')) return value.join(', ');
    return `${value.length} items`;
  }
  return JSON.stringify(value);
}

export function formatFieldLabel(key: string): string {
  return key
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Strip common entity prefixes from event codes and title-case the remainder */
export function formatEventCode(code: string): string {
  return code
    .replace(
      /^(PROVIDER_|MEDICAL_PROVIDER_|COVERAGE_|TASK_|STAFF_NOTE_|TREATMENT_REQUEST_)/,
      '',
    )
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
